import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";

const initState = {
    dtRequesteDate: new Date(),
    sTodoTitle: "",
    dtCompletionDate: null,
    toDoStatusID: 1,
    lToDoPriorityKey: null,
    requestedDeliveryYear: new Date().getFullYear(),
    requestedDeliveryQuarter: null,
    description: "",
}

export const todoItemConfig = {
    name: "DevelopmentTodoItemForm",
    initialState: initState,
    section: [
        {
            sectionId: 'basicDetailSection',
            title: "Basic User Details",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-12",
            },
            wrapperTemplate: <div className=" row mx-1 mb-2"></div>,
            fields: [

                {
                    id: "sTodoTitle",
                    label: "Title",
                    Field_Name: "Title",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "sTodoTitle",
                    fieldSetting: {
                        placeholder: "Enter Title",
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 mb-2 mt-2",
                    },
                },
                {
                    id: "toDoStatusID",
                    label: "Status",
                    Field_Name: "Status",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "toDoStatusID",
                    fieldSetting: {
                        placeholder: "Select Status",
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2",
                    },
                },
                {
                    id: "dtCompletionDate",
                    label: "Completion Date",
                    Field_Name: "Completion Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dtCompletionDate",
                    fieldSetting: {
                        isDisable: true,
                    },
                    // validation: [],
                    // validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2",
                    },
                },
                {
                    id: "lToDoPriorityKey",
                    label: "Priority",
                    Field_Name: "Priority",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "lToDoPriorityKey",
                    fieldSetting: {
                        placeholder: "Select Priority",
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2",
                    },
                },
                {
                    id: "dtRequesteDate",
                    label: "Request Date",
                    Field_Name: "Request Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "dtRequesteDate",
                    fieldSetting: {
                        allowSpace: false,
                        isDisable: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2 mt-2",
                    },
                },
                {
                    id: "sRequestedTimeframe",
                    label: "Request Timeframe",
                    Field_Name: "Request Timeframe",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    dataField: "sRequestedTimeframe",
                    fieldSetting: {
                        formTitle: "Request Timeframe",
                    },
                    style: {
                        containerCss: "col-12 my-2 text-left",
                    },
                },
                {
                    id: "requestedDeliveryYear",
                    label: "Year",
                    Field_Name: "Year",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "requestedDeliveryYear",
                    fieldSetting: {
                        dateConfig: {
                            displayYearPicker: true,
                            format: "yyyy"
                        }
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2",
                    },
                },
                {
                    id: "requestedDeliveryQuarter",
                    label: "Quarter",
                    Field_Name: "Quarter",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "requestedDeliveryQuarter",
                    fieldSetting: {
                        placeholder: "Select Quarter",
                        options: [
                            { value: 1, label: '1st' },
                            { value: 2, label: '2nd' },
                            { value: 3, label: '3rd' },
                            { value: 4, label: '4th' }
                        ]
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 mb-2",
                    },
                },
                {
                    id: "description",
                    label: "Description",
                    Field_Name: "Description",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "description",
                    fieldSetting: {
                        allowSpace: true,
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-6 mb-2",
                    },
                },
            ]
        },
    ]
} 